import { render, staticRenderFns } from "./WrapperView.vue?vue&type=template&id=6b031148"
import script from "./WrapperView.vue?vue&type=script&lang=js"
export * from "./WrapperView.vue?vue&type=script&lang=js"
import style0 from "./WrapperView.vue?vue&type=style&index=0&id=6b031148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports